'use client';
import { Controller } from 'react-hook-form';
import RadioButton from '@/app/components/ui/buttons/RadioButton/RadioButton';

const RadioGroup = ({ control, name, options = [], idPrefix = '' }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          {options.map((option, idx) => {
            const radioId = `${idPrefix}-${name}-${idx}`;
            return (
              <RadioButton
                key={radioId}
                id={radioId}
                name={name}
                text={option}
                checked={field.value === option}
                onChange={() => field.onChange(option)}
              />
            );
          })}
        </>
      )}
    />
  );
};

export default RadioGroup;
